<template>
  <!-- 인쇄할 때 표시 -->
  <div v-if="isPrint || readonly" class="fileupload-print print-container pb-8">
    <vs-row v-if="isShowTitle && !!sectionTitle" class="mt-6 mb-4">
      <vs-col>
        <div v-if="titleType === 'hint'">
          <div class="xl:flex items-start mb-4">
            <h5 style="align-self: center;"><i class="dot"></i>{{ sectionTitle }}</h5>
            <div class="flex items-center cursor-pointer">
              <feather-icon icon="AlertCircleIcon" class="ml-6 mr-1" style="cursor: pointer; width: 18px; color: #7e72f2" />
              <span style="color: #7e72f2"> {{hint}} </span>
            </div>
          </div>
        </div>

        <h5 v-else><i class="dot"></i>{{ sectionTitle }}</h5>
      </vs-col>
    </vs-row>
    <ul class="grid grid-cols-2 gap-5">
      <li v-for="(file, fileIndex) of printFile" :key="file.id">
        <div class="mb-2" v-if="gridTitle && gridTitle[fileIndex - 1]">{{ gridTitle[fileIndex - 1] }}</div>
        <div
          v-if="file.image && file.image.path"
          :style="{
            backgroundImage: 'url(' + file.image.path + ')',
            backgroundPosition: 'center center',
            cursor: 'pointer',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat'
          }"
          class="upload-content__file bg-center bg-no-repeat bg-contain"
          @click="onClickImage(file.image.path)"
        ></div>
        <div v-if="file.image && file.image.path" class="print-input mt-2">
          {{ file.input }}
        </div>
      </li>
    </ul>
  </div>

  <!-- 작성할 때 표시 -->
  <div v-else>
    <div class="grid xl:flex items-center mt-8 mb-4 gap-4">
      <!-- Title -->
      <div v-if="isShowTitle && !!sectionTitle" class="flex items-center">
        <div v-if="titleType === 'hint'">
          <div class="flex items-start">
            <h5 style="align-self: center;"><i class="dot"></i>{{ sectionTitle }}</h5>
            <div class="flex items-center cursor-pointer mt-2 xl:mt-0" @click="openPopup">
              <feather-icon icon="AlertCircleIcon" class="ml-6 mr-1" style="cursor: pointer; width: 18px; color: #7e72f2" />
              <span style="color: #7e72f2"> {{hint}} </span>
            </div>
          </div>
        </div>
        <h5 v-else class="flex items-center"><i class="dot"></i>{{ sectionTitle }}</h5>
      </div>
      <div v-else></div>

      <!-- Controller -->
      <div v-if="isCheckMode && !readonly && !isPrint" class="ml-auto">
        <vs-button color="secondary" @click="handleAdd"> 사진추가 </vs-button>
        <vs-button class="ml-4" color="secondary" type="border" @click="handleRemove"> 선택삭제 </vs-button>
      </div>
    </div>

    <div class="grid grid-cols-12 h-upload gap-5" :class="isShowTitle ? '' : 'mt-6'">
      <div v-for="(file, file_i) in fileList" :key="file_i" class="upload-content" :class="'col-span-' + Math.ceil(12 / setRowCount)">
        <!-- ========== Head ========== -->
        <div v-if="withDatePicker && withDatePickerPosition === 'top'" class="grid grid-cols-12 gap-x-6 gap-y-4 mb-4">
          <div class="items-center" :class="'col-span-' + (Math.ceil(12 / setRowCount) === 12 ? '12' : '6')"
               :style="Math.ceil(12 / setRowCount) === 12 ? {display: 'grid', gridTemplateColumns: '114px 1fr'} : {display: 'flex'}">
            <p v-if="!!datePickerTitle1" class="mr-2">{{ datePickerTitle1 }}</p>
            <p v-if="isPrint" class="print-input">{{ file.input }}</p>
            <ml-input v-else v-model="file.input" :placeholder="placeholder" class="w-full flex-1"/>
          </div>
          <div class="items-center" :class="'col-span-' + (Math.ceil(12 / setRowCount) === 12 ? '12' : '6')"
               :style="Math.ceil(12 / setRowCount) === 12 ? {display: 'grid', gridTemplateColumns: '114px 1fr'} : {display: 'flex'}">
            <p v-if="!!datePickerTitle2" class="mr-2">{{ datePickerTitle2 }}</p>
            <p v-if="isPrint" class="print-input">{{ file.input }}</p>
            <date-selector v-else class="w-full flex-1" v-model="file.date" :placeholder="placeHolderDatePicker" :readonly="readonly" />
          </div>
        </div>
        <div v-else class="mb-2" v-if="gridTitle && gridTitle[file_i]">{{ gridTitle[file_i] }}</div>

        <!-- ========== Image ========== -->
        <div class="upload-content__file">
          <vs-checkbox v-if="isCheckMode" v-model="file.checked" :style="'position: absolute; top: 0;'" class="mt-2 z-20" />
          <div
            class="upload-content__content"
            :style="{
              backgroundImage: `url(${!!file.image ? file.image.path : ''})`,
            }"
          >
            <img v-if="isPrint" class="w-full h-full printImg" :src="file.thumb" alt="" />
            <FileUploaderTransparent
              v-else
              style="background-size: contain; background-repeat: no-repeat"
              v-model="file.image"
              :readonly="readonly"
              @input="setFile(file_i, file.image)"
              @progress="(state) => { fileProgress(file_i, state) }"
            />
          </div>
          <simple-spinner
            v-if="file.showSpinner"
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #cdcdcdaa"/>
        </div>

        <!-- ========== Footer ========== -->
        <div v-if="withDatePicker && withDatePickerPosition === 'bottom'" class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
          <div class="items-center" :class="'col-span-' + (Math.ceil(12 / setRowCount) === 12 ? '12' : '6')"
               :style="Math.ceil(12 / setRowCount) === 12 ? {display: 'grid', gridTemplateColumns: '114px 1fr'} : {display: 'flex'}">
            <p v-if="!!datePickerTitle1" class="mr-2">{{ datePickerTitle1 }}</p>
            <p v-if="isPrint" class="print-input">{{ file.input }}</p>
            <ml-input v-else v-model="file.input" :placeholder="placeholder" class="w-full flex-1"/>
          </div>
          <div class="items-center" :class="'col-span-' + (Math.ceil(12 / setRowCount) === 12 ? '12' : '6')"
               :style="Math.ceil(12 / setRowCount) === 12 ? {display: 'grid', gridTemplateColumns: '114px 1fr'} : {display: 'flex'}">
            <p v-if="!!datePickerTitle2" class="mr-2">{{ datePickerTitle2 }}</p>
            <p v-if="isPrint" class="print-input">{{ file.input }}</p>
            <date-selector v-else class="w-full flex-1" v-model="file.date" :placeholder="placeHolderDatePicker" :readonly="readonly" />
          </div>
        </div>
        <div v-else class="upload-content__input mt-2">
          <div v-if="!notInput">
            <p v-if="isPrint" class="w-full">{{ file.input }}</p>
            <ml-input v-else class="w-full h-full" v-model="file.input" :placeholder="placeholder" :readonly="readonly" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TemplateFileUploadCheckList from "@/views/modules/template/TemplateFileUploadCheckList";
import TemplateFileUploadCheckListCol from "@/views/modules/template/TemplateFileUploadCheckListCol";
import TemplateFileUploadGallery from "@/views/modules/template/TemplateFileUploadGallery";
import FileUploaderTransparent from "@/components/FileUploaderTransparent2";
import DateSelector from "@/components/selector/DateSelector";
import SimpleSpinner from "@/components/spinner/SimpleSpinner.vue";


export default {
  name: "PhotoUploadGridModule",
  components: {
    SimpleSpinner,
    TemplateFileUploadGallery,
    TemplateFileUploadCheckListCol,
    TemplateFileUploadCheckList,
    FileUploaderTransparent,
    DateSelector,
  },
  props: {
    isCheckMode: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "check_list",
    },
    /** 이미지 업로드 그리드 개수 */
    gridCount: Number,

    /** 한 줄에 표시할 셀의 개수 (1 ~ 4) */
    rowCount: Number,

    /** 맨 위에 표시할 동그라미 제목 */
    sectionTitle: String,

    /** 파일 형식 상관없이 업로드할 수 있는 경우 TRUE */
    fileTypeAll: {
      type: Boolean,
      default: false,
    },

    /** date picker */
    withDatePicker: {
      type: Boolean,
      default: false,
    },
    withDatePickerPosition: {
      type: String,
      default: "bottom",
    },
    datePickerTitle1: String,
    datePickerTitle2: String,

    /** 맨 위의 동그라미 제목 표시 여부 */
    isShowTitle: {
      type: Boolean,
      default: true,
    },

    /** 인쇄용 화면일 경우 TRUE */
    isPrint: Boolean,

    /** 입력 창에 표시할 힌트 */
    placeholder: String,

    placeHolderDatePicker: {
      type: String,
      default: "날짜선택",
    },

    readonly: Boolean,
    id: String,
    value: Array, //{ id:0, fileName:'test1.txt', fileSize:1234, path:'', thumb:'', input:'' }
    multiStage: Number,

    /** 인풋창 제거 */
    notInput: Boolean,
    /** 그리드내 타이틀 */
    gridTitle: Array,

    /** 제목 타입 */
    titleType: String,
    hint: String,
  },
  watch: {
    value: {
      handler(value) {
        this.fileList = value;
      },
    },
    fileList: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    printFile() {
      return this.fileList.filter((file) => file.id !== 0);
    },
    setRowCount() {
      // 모바일 해상도일 경우 무조건 1개로 설정
      if (this.windowWidth < 768) {
        return 1;
      }

      if (4 < this.rowCount) return 4;
      else if (this.rowCount < 1) return 1;
      else return this.rowCount;
    },
  },
  data() {
    return {
      fileList: this.value,
      checkIndex: [],
      windowWidth: window.innerWidth,
    };
  },
  created() {
    this.fillEmptyFileList();
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    fillEmptyFileList() {
      for (let index = this.fileList.length; index < this.gridCount; index++) {
        this.fileList.push({showSpinner: false});
      }
    },
    handleAdd() {
      this.fileList.push({showSpinner: false});
    },
    handleRemove() {
      this.fileList = this.fileList.filter((fl) => !fl.checked);
    },
    setFile(index, file) {
      this.fileList[index].id = file ? file.id : null;
      this.fileList[index].path = file ? file.path : null;
      this.fileList[index].fileName = file ? file.fileName : null;
    },
    fileProgress (index, state) {
      console.log("fileProgress", index, state)
      if (state === 'start') {
        this.fileList[index].showSpinner = true;
      } else if (state === 'success') {
        this.fileList[index].showSpinner = false;
        this.$toast.open({type: 'default', message: '이미지 업로드가 완료되었습니다.', position: 'bottom', duration: 2000});
      } else if (state === 'fail') {
        this.fileList[index].showSpinner = false;
        this.$toast.open({type: 'error', message: '이미지 업로드가 완료되었습니다.', position: 'bottom', duration: 2000});
      }
    },
    // 읽기 전용에서, 이미지가 클릭됐을 때 새 창으로 이미지 표시
    onClickImage(src) {
      window.open(src, "_blank");
    },
    // hint
    openPopup() {
      this.$emit("openPopup");
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    }
  },
  // mounted() {
  //   setTimeout(() => {
  //     this.isPrint = true;
  //   }, 5000);
  // }
};
</script>

<style scoped lang="scss">
.upload-content__file {
  width: 100%;
  padding-top: 56.25%;
  position: relative;
  border: 1px dashed #cdcdcd;
  border-radius: 6px;

  .upload-content__content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;

    .printImg {
      background-color: white;
      border-radius: 6px;
    }
  }
}
</style>
